<template>
  <Modal
    v-model="showOrderdetail"
    title="订单详情"
    :footer-hide="true"
    width="1200"
  >
    <Tabs :value="type" :animated="false" style="padding-top: 10px">
      <TabPane label="投保信息" name="1">
        <my-form
          :formList="insurebase"
          :span="8"
          style="margin-top: 20px"
        ></my-form>
      </TabPane>
      <TabPane label="被保险人及保障权益" name="2">
        <interests :obj="detailInfo" />
      </TabPane>
    </Tabs>
  </Modal>
</template>

<script>
import { getOrdeDetail } from "@/api/httpList";
import myForm from "@/components/commons/form";
import interests from "./components/interests";
import insurebase from "./form/insurebase";
export default {
  components: {
    myForm,
    interests,
  },

  data() {
    return {
      showOrderdetail: false,
      type: "1",
      detailInfo: {},
      insurebase: [], //投保信息
    };
  },
  methods: {
    open(data) {
      this.showDetail(data);
    },

    async showDetail(row) {
      this.showOrderdetail = true;
      const res = await getOrdeDetail(row.orderNo);

      const obj = {
        orgName: res.data.organizationName,
        groupName: res.data.groupName,
        salesmanName: res.data.agentName,
      };
      this.detailInfo = Object.assign(res.data, obj);
      //回填基本信息
      this.insurebase = insurebase(this, row.status, this.detailInfo, row);
      this.insurebase[0].data.forEach((item) => {
        for (let key in res.data) {
          if (item.key == key) {
            item.value = res.data[key];
          }
          if (!item.value) {
            item.value = "-";
          }
        }
      });
      //投保人信息
      this.insurebase[1].data.forEach((item) => {
        for (let key in res.data.holder) {
          if (item.key == key) {
            item.value = res.data.holder[key];
          }
        }
      });
    },
  },
};
</script>

<style>
</style>